// extracted by mini-css-extract-plugin
export default {"ButtonBox":"SingleSelectionFromStringArray_ButtonBox__GGUMj"};